import * as React from "react"

const Profile = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M8 9.3a5.5 5.5 0 0 0-5.3 4h.7C4 11.4 5.8 10 8 10s4 1.4 4.6 3.3h.7c-.6-2.3-2.7-4-5.3-4Zm0-6a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM8 8a2.7 2.7 0 0 0 2.7-2.7A2.7 2.7 0 0 0 8 2.7a2.7 2.7 0 0 0-2.7 2.6A2.7 2.7 0 0 0 8 8Z" />
  </svg>
)

export default Profile
